import { CEDE_CEXS, CEDE_CEXS_SOON_SUPPORTED, EXCHANGES } from "../cexs";
import BINANCE_LOGO from "./assets/exchanges_logo/binance_logo.svg.js";
import BITFINEX_LOGO from "./assets/exchanges_logo/bitfinexLogo.svg.js";
import BITGET_LOGO from "./assets/exchanges_logo/bitgetLogo.svg.js";
import BITHUMB_LOGO from "./assets/exchanges_logo/bithumb_logo.svg.js";
import BITMART_LOGO from "./assets/exchanges_logo/bitmartLogo.svg.js";
import BITSTAMP_LOGO from "./assets/exchanges_logo/bitstampLogo.svg.js";
import BYBIT_LOGO from "./assets/exchanges_logo/bybit_logo.svg.js";
import COINBASE_LOGO from "./assets/exchanges_logo/coinbase.svg.js";
import CRYPTOCOM_LOGO from "./assets/exchanges_logo/cryptocom_logo.svg.js";
import DANGO_LOGO from "./assets/exchanges_logo/dango_logo.svg.js";
import DECIBEL_LOGO from "./assets/exchanges_logo/decibel_logo.svg.js";
import EXTENDED_LOGO from "./assets/exchanges_logo/extended_logo.svg.js";
import GATEIO_LOGO from "./assets/exchanges_logo/gateioLogo.svg.js";
import GEMINI_LOGO from "./assets/exchanges_logo/gemini_logo.svg.js";
import GRVT_LOGO from "./assets/exchanges_logo/grvt_logo.svg.js";
import HIBACHI_LOGO from "./assets/exchanges_logo/hibachi_logo.svg.js";
import HOTSTUFF_LOGO from "./assets/exchanges_logo/hotstuff_logo.svg.js";
import HTX_LOGO from "./assets/exchanges_logo/htxLogo.svg.js";
import HYPERLIQUID_LOGO from "./assets/exchanges_logo/hyperliquid_logo.svg.js";
import KATANA_LOGO from "./assets/exchanges_logo/katana_logo.svg.js";
import KRAKEN_LOGO from "./assets/exchanges_logo/kraken.svg.js";
import KUCOIN_LOGO from "./assets/exchanges_logo/kucoin.svg.js";
import LBANK_LOGO from "./assets/exchanges_logo/lbank_logo.svg.js";
import MEXC_LOGO from "./assets/exchanges_logo/mexc_logo.svg.js";
import OKX_LOGO from "./assets/exchanges_logo/okx_logo.svg.js";
import PARADEX_LOGO from "./assets/exchanges_logo/paradex_logo.svg.js";
import POLYMARKET_LOGO from "./assets/exchanges_logo/polymarket_logo.svg.js";
import RISE_LOGO from "./assets/exchanges_logo/rise_logo.svg.js";
import ZEROONE_LOGO from "./assets/exchanges_logo/zeroone_logo.svg.js";

export const EXCHANGE_LOGOS: { [key: string]: string } = {
  [CEDE_CEXS.COINBASE]: COINBASE_LOGO,
  [CEDE_CEXS.BINANCE]: BINANCE_LOGO,
  [CEDE_CEXS.KRAKEN]: KRAKEN_LOGO,
  [CEDE_CEXS.GATEIO]: GATEIO_LOGO,
  [CEDE_CEXS.OKX]: OKX_LOGO,
  [CEDE_CEXS.BITFINEX]: BITFINEX_LOGO,
  [CEDE_CEXS.HTX]: HTX_LOGO,
  [CEDE_CEXS.KUCOIN]: KUCOIN_LOGO,
  [CEDE_CEXS.BYBIT]: BYBIT_LOGO,
  [CEDE_CEXS.BITGET]: BITGET_LOGO,
  [CEDE_CEXS.BITSTAMP]: BITSTAMP_LOGO,
  [CEDE_CEXS.BITMART]: BITMART_LOGO,
  [CEDE_CEXS.MEXC]: MEXC_LOGO,
  [CEDE_CEXS.COINBASE_EXCHANGE]: COINBASE_LOGO,
  [CEDE_CEXS.CRYPTOCOM]: CRYPTOCOM_LOGO,
  [CEDE_CEXS.BITHUMB]: BITHUMB_LOGO,
  [CEDE_CEXS.HYPERLIQUID]: HYPERLIQUID_LOGO,
  [CEDE_CEXS.PARADEX]: PARADEX_LOGO,
  [CEDE_CEXS.GRVT]: GRVT_LOGO,
  [EXCHANGES.POLYMARKET]: POLYMARKET_LOGO,
  [CEDE_CEXS.EXTENDED]: EXTENDED_LOGO,
  [CEDE_CEXS.HIBACHI]: HIBACHI_LOGO,
  [CEDE_CEXS.HOTSTUFF]: HOTSTUFF_LOGO,
  [CEDE_CEXS.DANGO]: DANGO_LOGO,
  [CEDE_CEXS.RISE]: RISE_LOGO,
  [CEDE_CEXS.ZEROONE]: ZEROONE_LOGO,
  [CEDE_CEXS.DECIBEL]: DECIBEL_LOGO,
  [CEDE_CEXS.KATANA]: KATANA_LOGO,
  [CEDE_CEXS.KRAKEN_FUTURES]: KRAKEN_LOGO,
  [CEDE_CEXS.LBANK]: LBANK_LOGO,
  // not supported yet, but promoted on our landing
  [CEDE_CEXS_SOON_SUPPORTED.GEMINI]: GEMINI_LOGO,
  [CEDE_CEXS_SOON_SUPPORTED.BINANCE_US]: BINANCE_LOGO,
};
